// FunnelKeeper first-party snippet on the dashboard. Unset write key = no-op
// so local/dev never phones the warehouse. The snippet is the same GET /fk.js
// tenants install; we just load it ourselves.

import { API_BASE } from "./apiBase";

const rawKey = (import.meta.env.VITE_FK_WRITE_KEY ?? "").trim();
const rawOrigin = (import.meta.env.VITE_FK_API_ORIGIN ?? API_BASE).trim().replace(/\/$/, "");
export const FK_WRITE_KEY = /^fk_pub_[A-Za-z0-9_-]{16,}$/.test(rawKey) ? rawKey : "";
export const FK_API_ORIGIN = /^https?:\/\//i.test(rawOrigin) ? rawOrigin : "";

export type FkTrackOpts = {
  name?: string;
  email?: string;
  external_id?: string;
  dedupe_id?: string;
  value_cents?: number;
  currency?: string;
  kind?: string;
  score?: string | number;
  props?: Record<string, unknown>;
};

declare global {
  interface Window {
    fk?: {
      track: (stage: string, opts?: FkTrackOpts) => void;
      identify: (who: { email?: string; external_id?: string }) => void;
      ready?: boolean;
      q?: unknown[];
    };
  }
}

function stub(): NonNullable<Window["fk"]> {
  const q: unknown[] = [];
  return {
    q,
    ready: false,
    track(stage, opts) { q.push(["track", stage, opts]); },
    identify(who) { q.push(["identify", who]); },
  };
}

export function installFk(): void {
  if (typeof window === "undefined" || !FK_WRITE_KEY || !FK_API_ORIGIN) return;
  if (window.fk?.ready) return;
  window.fk = window.fk ?? stub();
  const s = document.createElement("script");
  s.async = true;
  s.src = `${FK_API_ORIGIN}/fk.js`;
  s.setAttribute("data-key", FK_WRITE_KEY);
  document.head.appendChild(s);
}

export function fkTrack(stage: string, opts: FkTrackOpts = {}): void {
  if (typeof window === "undefined" || !FK_WRITE_KEY || !stage) return;
  window.fk = window.fk ?? stub();
  window.fk.track(stage, opts);
}

export function fkIdentify(who: { email?: string; external_id?: string }): void {
  if (typeof window === "undefined" || !FK_WRITE_KEY) return;
  window.fk = window.fk ?? stub();
  window.fk.identify(who);
}
